import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_dialog_actions = _resolveComponent("ontos-dialog-actions")!
  const _component_ontos_page_header = _resolveComponent("ontos-page-header")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_ontos_dialog = _resolveComponent("ontos-dialog")!

  return (_openBlock(), _createBlock(_component_ontos_dialog, {
    "model-value": true,
    fullscreen: _ctx.$vuetify.display.smAndDown,
    "max-width": "1100px",
    "onUpdate:modelValue": _ctx.onDialogInput
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "image-preview" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "py-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_ontos_page_header, {
                title: _ctx.title,
                level: 2
              }, {
                controls: _withCtx(() => [
                  _createVNode(_component_ontos_dialog_actions, {
                    onClosed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closed')))
                  })
                ]),
                _: 1
              }, 8, ["title"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "image-preview-body" }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _ctx.src,
                alt: _ctx.title,
                class: "image-preview-image"
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["fullscreen", "onUpdate:modelValue"]))
}